











































import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload } from '@/tcw/api/types'
import BaseComponent from '@/tcw/components/BaseComponent'
import TcwPopupTag from '@/components/common/TcwPopupTag.vue'
import KintaiLockTag from '@/components/kintai/molecules/KintaiLockTag.vue'

@Component({
  components: { TcwPopupTag, KintaiLockTag }
})
export default class ShouninStatus extends Mixins(BaseComponent) {
  @Prop({ default: -1 })
  protected userId!: number
  @Prop({ default: () => null })
  protected teishutsu!: ApiGeneralSinglePayload | null

  @Emit()
  private clearKintaiCheckMode(): void {
    /** */
  }

  get statusTagClass(): { [key: string]: boolean } {
    return { 'status-tag': true, 'is-mobile': this.isMobile }
  }

  get shouninUserList(): ApiGeneralObjectArrayPayload {
    const shouninUserList = this.teishutsu?.shouninUserList
    if (shouninUserList && Array.isArray(shouninUserList)) {
      return shouninUserList as ApiGeneralObjectArrayPayload
    }
    return []
  }
  get hasBall(): boolean {
    return this.shouninUserList.some(user => user.id === this.loginUserId)
  }
}
